import { useContext } from 'react'
import { CourseContextsResetContext } from '@contexts/CourseContextsReset'

export const useCourseContextsReset = () => {
  const context = useContext(CourseContextsResetContext)

  if (!context) {
    throw new Error(
      'useCourseContextsReset must be used within a CourseContextsResetProvider',
    )
  }

  return context
}
